import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const requiredMsg = 'This field is required'
const schema = {
  firstName: Yup.string().nullable(),
  lastName: Yup.string().nullable(),
  firstNameLegal: Yup.string().nullable(),
  lastNameLegal: Yup.string().nullable(),
  email: Yup.string().email('Must be a valid email').nullable(),
  role: Yup.string().nullable(),
  phone1: Yup.string().nullable(),
  phone2: Yup.string().nullable(),
  locationId: Yup.string().nullable(),
  notes: Yup.string().nullable(),
  address1: Yup.string().nullable(),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable(),
  zip: Yup.string().nullable(),
  idType: Yup.string().nullable(),
  licenseExpiration: Yup.mixed().nullable(),
  licenseNumber: Yup.string().nullable(),
  height: Yup.string().nullable(),
  eyes: Yup.string().nullable(),
  gender: Yup.string().nullable(),
  hair: Yup.string().nullable(),
  birthDate: Yup.mixed().nullable(),
  licenseImage: Yup.string().nullable(),
  licenseImageBack: Yup.string().nullable(),
}

export const contactsSchema = {
  contactsArray: Yup.array().of(Yup.object().shape(schema)),
}

export const contactsSchemaForSupplier = {
  contactsArray: Yup.array().of(
    Yup.object().shape({
      ...schema,
      firstNameLegal: Yup.string().nullable().required(requiredMsg),
      lastNameLegal: Yup.string().nullable().required(requiredMsg),
    }),
  ),
}

const validationSchema = Yup.object().shape({
  contacts: contactsSchema.contactsArray,
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
